module.exports = __webpack_public_path__ + "static/Permissions-27d428a5e2ca52be568b4ba3efd73f00.png";